import { render, staticRenderFns } from "./SubSamplePhoto.vue?vue&type=template&id=db1d0d34"
import script from "./SubSamplePhoto.vue?vue&type=script&lang=js"
export * from "./SubSamplePhoto.vue?vue&type=script&lang=js"
import style0 from "./SubSamplePhoto.vue?vue&type=style&index=0&id=db1d0d34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports